import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';

import { RequestError } from '@/store';

interface RequestErrorSnackbarProps {
  errors: readonly RequestError[];
  onRetry: () => void;
}

function RequestErrorSnackbar(props: RequestErrorSnackbarProps) {
  const { errors, onRetry } = props;
  return (
    <Snackbar
      open={errors.length > 0}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={6000}
    >
      <Alert
        severity="error"
        sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1 }}
        action={
          <Button color="secondary" size="small" onClick={onRetry}>
            Retry
          </Button>
        }
      >
        <Typography>
          An error occured while fetching resources from backend.
        </Typography>
        <Typography>Please retry or contact an administrator.</Typography>
      </Alert>
    </Snackbar>
  );
}

export { RequestErrorSnackbar };
